export { default } from "./ReadComment";
